export default function AnalyticsCard({ title, children, className }) {
  return (
    <div className={`bg-background-secondary rounded-lg border border-border-primary shadow-sm ${className || ''}`}>
      {title && (
        <div className="px-5 py-3.5 border-b border-border-primary">
          <h2 className="text-sm font-semibold text-text-primary">{title}</h2>
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}
